import { useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';

import Axios from '@/lib/axios-instance';

type APIPayload = {
  website_type: string;
  website_url: string;
  shopify_access_token?: string;
  shopify_api_secret?: string;
  shopify_api_key?: string;
  mode?: string;
  locator?: string;
};

export const updateWebSettings = async (payload: APIPayload) => {
  try {
    const response = await Axios.put('/web_settings', payload);
    return response.data;
  } catch (error: any) {
    throw error?.response?.data;
  }
};

export const useUpdateWebSettings = () => {
  return useMutation({
    mutationFn: (payload: APIPayload) => updateWebSettings(payload),
    onSuccess: (data) => {
      toast.success('Web settings created successfully');
      console.log({ data });
    },
    onError: (error) => {
      toast.error('Unable to create web settings.', {
        description: error.message,
      });
      console.log({ error });
    },
  });
};
